(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1783,8691],{

/***/ 4330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EbookDownloadSection; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31741);
/* harmony import */ var components_templates_common_post_FormDownloadModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53693);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function EbookDownloadSection(_ref) {
  var title = _ref.title,
      imgSrc = _ref.imgSrc,
      sectionClass = _ref.sectionClass,
      children = _ref.children,
      dataForm = _ref.dataForm,
      hash = _ref.hash,
      wrapper = _ref.wrapper,
      url = _ref.url;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showFormDownload = _useState[0],
      setShowFormDownload = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      haveFormDownload = _useState2[0],
      setHaveFormDownload = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (document.getElementById("shortcode_download_form")) {
      setHaveFormDownload(true);
      document.querySelectorAll("#shortcode_download_form .btn").forEach(function (item) {
        item.addEventListener("click", function () {
          setShowFormDownload(true);
        });
      });
    }
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: wrapper === null || wrapper === void 0 ? void 0 : wrapper.className,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "row justify-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        id: "ebook-download",
        className: "m-auto lg:col-10 lg:px-0",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          text: title,
          className: "bbc-title mb-6 px-5 text-center capitalize lg:mb-10 lg:px-0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "row flex-col-reverse justify-between lg:flex-row ".concat(sectionClass || ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex items-center justify-center lg:col-5",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({
              className: " mt-6 w-full lg:mt-0",
              width: 360,
              height: 515
            }, imgSrc))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "lg:col-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              children: children
            }), dataForm ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              id: "shortcode_download_form",
              className: "btn mt-6 text-center lg:text-left",
              "data-type-shortcode": dataForm,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "outline",
                className: "btn rounded-full border border-bbc-primary bg-transparent py-2 px-6 font-semibold text-bbc-primary hover:bg-bbc-primary hover:text-white",
                children: "Download Now"
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "mt-6 text-center lg:text-left",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: hash,
                variant: "outline",
                as: "a",
                href: url,
                children: "Download Now"
              })
            })]
          })]
        }), haveFormDownload && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_templates_common_post_FormDownloadModal__WEBPACK_IMPORTED_MODULE_5__["default"], {
          show: showFormDownload,
          onHide: function onHide() {
            return setShowFormDownload(false);
          },
          typeFormDownload: dataForm
        })]
      })
    })
  });
}

/***/ }),

/***/ 78354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["title", "subTitle", "data", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/** ========== */




var Component = function Component(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      data = _ref.data,
      children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "row gap-y-6 lg:justify-end lg:gap-y-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "col-12 lg:col-4",
          children: children ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            className: "text-center font-semibold lg:text-left",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "block text-bbc-40px text-bbc-brand-800",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "mt-4 block text-2xl  leading-9 ".concat(subTitle && subTitle === "in 4 easy steps" ? "text-bbc-brand-600" : "text-bbc-brand-800"),
              children: subTitle
            })]
          })
        }), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "h3",
                className: "mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                className: "leading-bbc-26 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })]
            })
          }, index);
        })]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 18691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91164);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["className", "description", "imgAlt", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var StepSlider = function StepSlider(_ref) {
  var className = _ref.className,
      description = _ref.description,
      imgAlt = _ref.imgAlt,
      data = _ref.data,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: " pt-10 lg:pt-24 ".concat(className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        text: data.title,
        as: "h2",
        className: " mb-6 text-center text-3xl font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-4xl"
      }), description ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("p", {
        className: "mb-10 text-center",
        children: [" ", description]
      }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "row justify-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 mb-6 flex items-center justify-center lg:col-4 lg:mb-0 lg:justify-start",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            src: "/assets/images/offshore/country/bvi/bank_account-bvi.png",
            alt: imgAlt,
            width: 351,
            height: 350
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-3 flex items-center justify-center lg:col-1 lg:order-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "swiper-pagination-custom flex h-6 items-end justify-center lg:h-[370px] lg:w-fit lg:flex-col lg:pr-4"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-2 self-center lg:col-6 lg:order-3 ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, _objectSpread(_objectSpread({
              slidesPerView: 1,
              spaceBetween: 30,
              mousewheel: true,
              allowTouchMove: true,
              effect: "fade",
              fadeEffect: {
                crossFade: true
              },
              pagination: {
                el: ".swiper-pagination-custom",
                clickable: true,
                bulletClass: "pagination-bullet ",
                bulletActiveClass: "pagination-bullet-active bbc-pagination-bullet-active"
              },
              breakpoints: {
                320: {
                  allowTouchMove: true
                },
                1024: {
                  allowTouchMove: true
                }
              },
              modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Mousewheel */ .Gk, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .EffectFade */ .xW],
              className: "mySwiper"
            }, props), {}, {
              children: data.steps && data.steps.length > 0 && data.steps.map(function (step, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                  className: "h-auto",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: "step-slider h-full rounded-xl bg-transparent p-0 lg:bg-white lg:px-10 lg:pb-10 lg:pt-6",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                      as: "h3",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-1 block text-lg font-medium text-bbc-brand-700",
                        children: step.index
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-6 block text-lg font-semibold text-bbc-brand-600 lg:text-2xl",
                        children: step.titleStep
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                      className: "text-bbc-gray",
                      dangerouslySetInnerHTML: {
                        __html: step.description
                      }
                    })]
                  })
                }, index);
              })
            }))
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (StepSlider);
StepSlider.defaultProps = {
  className: ""
};

/***/ }),

/***/ 53693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/**
 * Vendor
 */

/**
 * Components
 */




var FormDownload = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9885), __webpack_require__.e(9669), __webpack_require__.e(7445)]).then(__webpack_require__.bind(__webpack_require__, 37445));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37445)];
    },
    modules: ["../components/templates/common/post/FormDownloadModal/index.js -> " + "./FormDownload"]
  }
});

var FormDownloadModal = function FormDownloadModal(_ref) {
  var descriptionClass = _ref.descriptionClass,
      checkboxTextClassName = _ref.checkboxTextClassName,
      show = _ref.show,
      onHide = _ref.onHide,
      typeFormDownload = _ref.typeFormDownload;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FormDownload, {
        descriptionClass: descriptionClass,
        checkboxTextClassName: checkboxTextClassName,
        show: show,
        onHide: onHide,
        typeFormDownload: typeFormDownload
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FormDownloadModal);
/** ========== */

/***/ }),

/***/ 41956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9749);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CompanyNameCheck = function CompanyNameCheck(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: "bg-bbc-gradient-9",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "row py-6 lg:py-0",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "col-12 mb-10 self-center lg:col-5 lg:mb-0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            text: data.title,
            as: "h2",
            className: "mb-6 pr-0 text-bbc-30px font-semibold capitalize text-bbc-main"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
            className: "mb-6 text-base font-normal text-white",
            children: data.description
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "text-center lg:text-left",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: "/guide-and-tool/singapore-company-name-check",
              target: "_blank",
              className: "inline-block bg-bbc-brand-500 px-6 py-2 font-medium text-white",
              style: {
                borderRadius: "50px"
              },
              children: "Get Started"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "col-12 relative my-0 text-center lg:col-7 lg:my-28 lg:text-left",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, data.image)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "absolute hidden items-center justify-center rounded-lg bg-white px-10  py-4 ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().nation)),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              className: "mr-3",
              src: "/assets/icons/nation.svg",
              alt: "online baking tool"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "text-sm font-medium text-bbc-brand-700",
              children: "Nation"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "shadow-bbc absolute hidden items-center justify-center rounded-lg bg-white px-10 py-4 ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().emailAddress)),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              className: "mr-3",
              src: "/assets/icons/mail-switch.svg",
              alt: "online baking tool",
              width: 22,
              height: 24
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "text-sm font-medium text-bbc-brand-700",
              children: "Email Address"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "shadow-bbc absolute hidden items-center justify-center rounded-lg bg-white px-10 py-4 ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().entityName)),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              className: "mr-3",
              src: "/assets/icons/user-switch.svg",
              alt: "user-switch",
              width: 22,
              height: 24
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "text-sm font-medium text-bbc-brand-700",
              children: "Entity Name"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "shadow-bbc absolute hidden items-center justify-center rounded-lg bg-white px-10 py-4 ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().entityType)),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              className: "mr-3",
              src: "/assets/icons/entity-type.svg",
              alt: "user-switch",
              width: 22,
              height: 24
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "text-sm font-medium text-bbc-brand-700",
              children: "Entity Type"
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CompanyNameCheck);
CompanyNameCheck.defaultProps = {
  className: ""
};

/***/ }),

/***/ 59490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/atoms/CheckContent/index.js
var CheckContent = __webpack_require__(36484);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormCountries/index.js
var FormCountries = __webpack_require__(88279);
// EXTERNAL MODULE: ./components/molecules/FormNewsletter/index.js
var FormNewsletter = __webpack_require__(32314);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/EbookDownload/index.js
var EbookDownload = __webpack_require__(4330);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/HowItWorks/index.js
var HowItWorks = __webpack_require__(78354);
// EXTERNAL MODULE: ./components/organisms/OffshoreCompanyRegistration/index.js
var OffshoreCompanyRegistration = __webpack_require__(58720);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./components/organisms/StepSlider/index.js
var StepSlider = __webpack_require__(18691);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/index.js + 2 modules
var WhatMakeUsDifferent = __webpack_require__(58722);
// EXTERNAL MODULE: ./components/templates/sg/company-incorporation/CompanyNameCheck/index.js
var CompanyNameCheck = __webpack_require__(41956);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/sg/company-incorporation/index.js



















var NewsSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 5593).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/sg/company-incorporation/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var SGCompanyIncorporationTemplate = function SGCompanyIncorporationTemplate(_ref) {
  var data = _ref.data,
      dataJson = _ref.dataJson;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-635",
      breadcrumbs: dataJson.breadcrumbs,
      title: "Company Incorporation <br/>In Singapore",
      titleProps: {
        className: "banner-default-title mb-6 lg:mb-10 capitalize",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/sg/company-incorporation/banner-sg-incorporation.png",
        wrapper: {
          className: "bbc-banner-image-country pb-10 lg:pb-0 "
        },
        className: "w-full",
        width: 560,
        height: 456,
        priority: true,
        alt: "Singapore company incorporation service"
      }),
      bgColor: "bg-bbc-country",
      dataTrustpilot: {
        dataStatic: dataJson.dataTrustpilot,
        dataDefault: data.dataTrustpilot
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OffshoreCompanyRegistration/* default */.Z, {
        data: dataJson.dataRegistration
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      src: "/assets/images/wave/opposition-wave.png",
      width: 1920,
      height: 86,
      className: "hidden w-full lg:block",
      wrapper: {
        className: "w-full"
      },
      alt: "Wave opposition"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:bg-bbc-brand-100",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mb-10 items-center pt-0 lg:mb-20 lg:pt-20",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "justify-self-start lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                text: "Bring Your Next<br/> Business Venture Online",
                className: "bbc-title mb-6 text-center text-bbc-30px text-bbc-brand-800 lg:mb-0 lg:text-left lg:text-bbc-40px"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                  src: "https://www.youtube.com/embed/8RkJwKEXKPU?start=2",
                  width: "540",
                  height: "303",
                  frameBorder: "0",
                  title: "Bring your next business venture online",
                  allow: "accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture",
                  allowFullScreen: true,
                  className: " w-full"
                })
              })
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferent/* default */.Z, {
          title: "",
          data: dataJson.dataWhatMakeUsDifferent,
          className: "bg-wmud py-[60px]"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        children: dataJson.dataOpenBankAccount && typeof dataJson.dataOpenBankAccount === "object" && Object.keys(dataJson.dataOpenBankAccount).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(StepSlider["default"], {
          data: dataJson.dataOpenBankAccount,
          className: "pt-0 lg:pt-0",
          title: dataJson.dataOpenBankAccount.title,
          imgAlt: dataJson.dataOpenBankAccount.alt
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
          title: "What documents to prepare?",
          data: dataJson.dataRequiredDocument,
          sectionClassName: "py-10 lg:py-20",
          backgroundImage: "/assets/images/common/required-documents.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(EbookDownload/* default */.Z, {
            title: dataJson.dataEbookDownload.title,
            imgSrc: dataJson.dataEbookDownload.imgSrc,
            contactFromId: dataJson.dataEbookDownload.contactFromId,
            hash: dataJson.dataEbookDownload.hash,
            dataForm: dataJson.dataEbookDownload.dataForm,
            wrapper: {
              className: "mb-10 lg:mb-20"
            },
            alt: dataJson.dataEbookDownload.alt,
            form: dataJson.dataEbookDownload.form,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-6",
              children: "Chart out a clear roadmap towards company formation with our Singapore Incorporation checklist. Start your journey with the following insights on"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: ["Company pre-incorporation requirements", "Compact guideline of application procedures", "Checklist of business licenses", "Post-incorporation and annual compliance keynotes"].map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  className: "mb-2 last:mb-0",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                    data: item
                  })
                }, index);
              })
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
          title: "How we register your company",
          subTitle: "in 4 easy steps",
          data: dataJson.dataHowItWorks
        })
      })]
    }), dataJson.dataCompanyNameCheck && typeof dataJson.dataCompanyNameCheck === "object" && Object.keys(dataJson.dataCompanyNameCheck).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyNameCheck/* default */.Z, {
        data: dataJson.dataCompanyNameCheck
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " absolute hidden h-1/2 w-full md:block lg:bg-bbc-brand-100"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container relative z-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCountries/* default */.Z, {
            title: dataJson.dataFormContact.title,
            description: dataJson.dataFormContact.description,
            country_id: 191
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/opposition_bottom-wave.png",
        width: 1920,
        height: 86,
        className: "hidden  w-full lg:block",
        wrapper: {
          className: "absolute w-full top-1/2 hidden md:block"
        },
        alt: "Wave bottom"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs,
            title: dataJson.dataFaqs.title,
            description: dataJson.dataFaqs.description,
            defaultActiveKey: dataJson.dataFaqs.defaultActiveKey,
            multipleOpen: dataJson.dataFaqs.multipleOpen
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-10 lg:mb-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormNewsletter/* default */.Z, {})]
  });
};

/* harmony default export */ var company_incorporation = (SGCompanyIncorporationTemplate);
;// CONCATENATED MODULE: ./pages/sg/company-incorporation/data.json
var data_namespaceObject = JSON.parse('{"country":"Singapore","banner_image":"singapore-incorporation.png","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Company Registration","uri":"/company-incorporation"}],"dataTrustpilot":{"content":{"button_placeholder":false,"benefits":["Company registration in 1 day","Open bank account online","Dedicated support","Automated and streamlined process"]}},"dataAnyIndustry":[{"icon":"ecommerce.svg","title":"ECommerce","description":"Singapore maintains a great logistic infrastructure and a robust digital payment foundation that\'s open to change. With a total market value of $3.7billion, it\'s more than just promising to capitalize on this lucrative industry. "},{"icon":"healthcare.svg","title":"Healthcare","description":"Healthcare is getting big in Singapore. According to Food and Health Bureau, the total public and private health expenditure in Singapore alone controls 6.8% of the country\'s GDP. "},{"icon":"user-headset.svg","title":"Cosmetics & Personal Care","description":"Beauty products have been seeing a consistent growth in demand in Singapore. In 2019, imports of cosmetic and personal care items amounted to over HK$47billion in 2019, an attractive incentive those that want to enter the beauty business."},{"icon":"two-bags.svg","title":"Retail","description":"Shopping is one of the most common phenomenons for the large population of Singapore\'s most savvy shoppers. Within the maze-like structure of Singapore\'s urban jungle are over 63,000 sprawling shopping malls and retail establishments of all sizes. "},{"icon":"maintenance.svg","title":"Technology","description":"When it comes to being a central hub for IT and technology development, Singapore is a name that can now rival even Guangdong and Shenzen  Together, these major tech regions form the world\'s second largest technology cluster according to Global Innovation Index 2020."},{"icon":"plane.svg","title":"Travel & Hospitality","description":"Tourism is one of the main economic pillars that keeps the lifeblood of this bustling state running. In 2018, around 4.5% of the country\'s GDP was from this industry alone, and along it are around 257,000 employed professionals."},{"icon":"column-chart.svg","title":"Finances","description":"Solid banking landscap e, deep capital market and asset management are what define Singapore\'s place as a premium spot for investors worldwide. This is further supported by its robust ranking amongst the top international financial centres on GFCI."},{"icon":"education.svg","title":"Education","description":"Considered an academic mecca of the Asia region, Singapore has been an industry-leading figure in education since the turn of the century. Parents spend on average +$130,000 on their kids\' educational wellbeing which includes schooling, transportation and accommodation "}],"dataRegistration":{"country":"Company Registration in Singapore","title":"Company Registration in Singapore ","data_top_left":[],"data_left":["Pro-business environment with corporate income tax capped at 17%","Partial tax exemption scheme for companies and new startups in Singapore","Avoidance of Double Taxation Agreements with over 70 countries","Investment Guarantee Agreements with 41 countries","Free Trade Agreements with 26 countries","The largest corporate banking centre in Asia","Excellent standards of livings","Well-developed financial markets and system"],"data_right":[{"title":"Private Limited Company","list_regulation":[{"title":"At least one director","icon":"director-shareholder.svg"},{"title":"Local registered address","icon":"location-user.svg"},{"title":"Incorporation accomplished within 3 hours","icon":"clock.svg"},{"title":"Customized company package","icon":"maintenance.svg"},{"title":"No hidden fee","icon":"fee.svg"},{"title":"All-in-one service","icon":"mail-switch.svg"}]}]},"dataOpenBankAccount":{"title":"Singapore company formation process","image":{"src":"/assets/images/offshore/country/bvi/bank_account-bvi.png","width":350,"height":350},"alt":"steps to register a company in Singapore","steps":[{"index":"Step 1: ","titleStep":"Select company name and types","description":"To set up a company in Singapore, you must first acquire a name that\'s available and in line with statutory requirements.<br/><br/>Typically, there are universal guidelines to choosing a name for your business: availability, appropriateness and uniqueness. As for choosing an entity type, it\'s best to go with the one that suits business needs to the most."},{"index":"Step 2:","titleStep":"Submit application","description":"You will need to ascertain information on the directors, shareholders, or other key personnels, in prelude to submitting them along with your chosen company name to the Accounting and Corporate Regulatory Authority (ACRA)."},{"index":"Step 3:","titleStep":"Apply for business license","description":"By law, all companies must obtain a business license as either as a sole trader or a registered business. Depending on the nature of your business, additional vetting by industry-specific inspectors and consulting agencies may become a prerequisite before your application is approved."},{"index":"Step 4:","titleStep":"Open a bank account","description":"The final step before your company can get off the ground is to open a bank account.<br/><br/>Neobanks like Aspire, Wise, Payoneer can speed up the process exponentially with their cloud-based solutions. For a more robust option, you can also consider opening traditional bank accounts in Singapore which is considered a banking hub on a global scale."},{"index":"Step 5:","titleStep":"Stay compliant","description":"Singapore is among the top jurisdictions for doing business in its region. This presents a higher compliance ceiling for those who wish to incorporate here, with key requirements being the annual returns filing, registered office maintenance, etc."}]},"dataPackage":{"title":"Singapore Company Incorporation Packages","listPackage":[{"id":4,"country_id":191,"kind":"Startup for locals","kind_mobile":"Basic","price":675,"className":"","banner":"","checkName":true,"suffix_name":"Private Limited","content":[{"subTitle":"Company Formation","listContent":[{"text":"Unlimited Name Availability Check","checkName":true},{"text":"Document Preparation and Filing"},{"text":"Company incorporation process"},{"text":"Company name reservation"},{"text":"Government registration fee"},{"text":"Lifetime Support/ Instant Response"},{"text":"Digital Corporate Documents"}]},{"subTitle":"01 year Company Secretary, including","listContent":[{"text":"Annual filing and AGM preparation"},{"text":"Annual filing government fee"}]},{"subTitle":"Bank account opening with Singapore banks"}],"notes":["* Annual renewal fee at US$ 440","** All documents are prepared according to the regulations issued by Accounting and Corporate Regulatory Authority of Singapore (ACRA)"]},{"id":6,"kind":"standard","kind_mobile":"Standard","price":1950,"className":"","banner":"","content":[{"subTitle":"Everything in Startup package, plus","listContent":[{"text":"Nominee director in the first year"},{"text":"01 year Local Registered Address with mail handling"}]},{"subTitle":"Add-on Accounting package: from US$ 75/month billed yearly","description":"<i>*a must-have with the Nominee director service</i>","listContent":[{"text":"Xero cloud accounting"},{"text":"Corppass registration"},{"text":"Monthly accounting review"},{"text":"Monthly preparation of FSs"},{"text":"Annual tax filing (preparation and filing of ECI and Form C/C-S)"},{"text":"Annual revenue under $100k (plan upgradable on request)"}]}],"notes":["* This Package includes everything for a foreigner to set up a new Singapore private limited company from the beginning","** Nominee review fee of $40/month billed yearly will be charged should you not use our accounting service","*** Annual renewal fee at US$ 1,940"]},{"id":7,"kind":"Standard with Employment Pass","kind_mobile":"Premium","price":1985,"className":"","content":[{"subTitle":"Everything in Standard package with Nominee Director for the first 6 months, plus","listContent":[{"text":"Application of Employment Pass"}]},{"subTitle":"Add-on Accounting package: from US$ 75/month billed yearly","description":"<i>*a must-have with the Nominee director service</i>","listContent":[{"text":"Xero cloud accounting"},{"text":"Corppass registration"},{"text":"Monthly accounting review"},{"text":"Monthly preparation of FSs"},{"text":"Annual tax filing (preparation and filing of ECI and Form C/C-S)"},{"text":"Annual revenue under $100k (plan upgradable on request)"}]}],"notes":["* Annual renewal fee at US$ 440 excl. Work pass renewal"]}]},"dataWhatMakeUsDifferent":[{"title":"Streamlined process","description":"Start at your own pace. And reduce waiting time for back-and-forth email communication.","img_src":"/assets/images/common/process-wmud.png","img_alt":"streamlined incorporation process"},{"title":"E-signature","description":"Collaborate with your partner more easily. Less paperwork, more efficiency.","img_src":"/assets/images/common/e_signature-wmud.png","img_alt":"e-signature"},{"title":"Digitized KYC","description":"Standardized form & organizational chart to let you control and declare your information effortlessly.","img_src":"/assets/images/common/kyc-wmud.png","img_alt":"digitized kyc process"},{"title":"Centralized management portal","description":"24/7 access to company documents on high-security cloud infrastructure. And no worry about key compliance deadlines with auto reminder.","img_src":"/assets/images/common/portal-wmud.png","img_alt":"company management portal"}],"openBusinessAccount":true,"dataHowItWorks":[{"title":"Place your order","content":"Enter our online order platform for easy onboarding experience and tailor your orders. We have different packages and additional services that suit your goals. All information filled in is secured over 256-bit encrypted line."},{"title":"Make payment","content":"Your settlement can be made online via Credit card, Debit Card. Bank wire transfer is also acceptable."},{"title":"Collect and verify KYC documents","content":"Once we\'ve received your payment, our customer service will contact you to process the neccessary paperwork. We\'ll guide you to properly prepare documents for incorporation via KYC online form. And you can also access our digital Client Portal to proceed with the incorporation steps and keep track of the process anytime, anywhere."},{"title":"Singapore company registration","content":"The electronic documents are ready after 1 working day of Singapore company registration, and it takes 3-7 day for courier the original ones."}],"dataRequiredDocument":{"title":"What documents to prepare?","content":[{"title":"","listContent":[{"text":"Passport of all shareholders/directors","content":[]},{"text":"Address proof of all shareholders/ directors i.e. identity card, bank statement, driving license, utility bill","content":[]},{"text":"10-seconds selfie video of each member holding his/her passport, and speaking their name, passport number, and the service you need","content":[]}]}]},"dataEbookDownload":{"title":"Singapore incorporation checklist download","imgSrc":{"src":"/assets/images/sg/company-incorporation/ebook-sg-incorporation.png","alt":"ebook Singapore incorporation checklist","width":351,"height":340},"imgLeft":{"src":"/assets/images/sg/common/checklist-sg-common.png"},"triggerName":"Incorporation Checklist - Singapore","apiLink":"api/portal/contact_form/ebook","contactFromId":37,"dataForm":"checklist_singapore"},"dataCompanyNameCheck":{"title":"Company Name <br class=\'hidden lg:block\'/>Check","description":"Check if your company name is available today with our Entity Name Check Tool.","image":{"src":"/assets/images/sg/company-incorporation/laps-sg-incorporation.png","width":597,"height":345,"alt":"Singapore company name check"}},"dataFormContact":{"title":"Wish to get a hassle-free Singapore company incorporation?","description":"Just get in touch with us. We typically response within 2 hrs."},"dataFaqs":{"activeTab":0,"data":[{"name":"Incorporation","faqs":[{"name":"What are initial requirements to register a company in Singapore?","content":"<ul><li>Minimum one director and one shareholder.</li><li>Local resident director(s).</li><li>A local registered address in Singapore.</li></ul>"},{"name":"What kinds of business are allowed in Singapore?","content":"<p>Generally, no restrictions except for financial services, education, media-related or other politically sensitive businesses.</p>"},{"name":"Can a foreigner register a company in Singapore?","content":"<p>It\'s totally possible for a foreigner to opt for company registration in Singapore. According to Singapore Companies Act, 100% ownership of a Singapore company is permitted, either for a local person or a foreigner.</p>"},{"name":"Is there any Double tax treaty (DTT) signed by Singapore?","content":"<p>Singapore has an extensive investment protection agreement and double tax treaty network. This includes most countries in the Asia-Pacific Region and countries in Europe, Africa and the Middle East. These countries include China, Indonesia, Thailand, Malaysia, Philippines, Vietnam, India, Japan, Korea, Australia, New Zealand, South Africa, United Kingdom, Netherlands, Germany, Switzerland, Sweden, France, Belgium, Finland and the United Arab Emirates.</p><p>Singapore is also one of the very few countries to have a tax treaty with Taiwan. This explains the popularity of Singapore holding companies for Taiwanese investments into China and the region.</p>"},{"name":"How many types of company are available for incorporation in Singapore?","content":"<p>Types of company that can be registered in Singapore are:</p><ul><li>Public/Private company limited by shares;</li><li>Company limited by guarantee;</li><li>Unlimited company.</li></ul><p>Singapore private limited company by shares is the most popular form, while company limited by guarantee is often used for non-profit purposes. Moreover, there are also exempt private companies eligible for certain privileges for small enterprises.</p>"}]},{"name":"Corporate structure","faqs":[{"name":"What is the minimum number of directors/shareholders required for a Singapore private company?","content":"<p>A minimum of one director (for both individual and corporate), who must be a Singapore natural resident is required. To fulfill this obligation, BBCIncorp could assist you in appointing a Singapore professional director. A foreigner who wants to register a new company in Singapore and act as a resident director of the company or operate the company, must first obtain a valid pass from the government.</p><p>The minimum of one shareholder is a must. Shareholders may be corporations or individuals. 100% foreign ownership is allowed. The maximum number of shareholders for a private company is fifty (50).</p>"},{"name":"Is information of company directors/shareholders made public?","content":"<p>Names and addresses of company directors/shareholders are publicly disclosed.</p>"},{"name":"Is there any requirement for registered capital?","content":"<p>The concept of authorized share capital has been abolished in Jan 2006 and the minimum number of issued share is one.</p>"},{"name":"What classes of shares are permitted under current law?","content":"<p>Some of the typical classes of shares include ordinary shares, preference shares and redeemable shares, non-voting shares.</p>"}]},{"name":"Compliance tasks","faqs":[{"name":"Do I have to file annual returns for my Singapore company?","content":"<p>In Singapore, it is mandatory for a company to file annual returns with Accounting and the Corporate Regulatory Authority (ACRA), and annual tax returns with the Inland Revenue Authority of Singapore (IRAS).</p>"},{"name":"What are annual maintenance requirements to keep a Singapore company in good standing?","content":"<p>In order to comply with local regulation, a private company has to maintain the followings:</p><ul><li>Corporate structure of at least one natural resident director, one shareholder;</li><li>Local company secretary and a registered address in Singapore;</li><li>Filing annual return with ACRA and tax return with IRAS together with annual audited accounts. The accounts must be audited by a registered certified public accountant in Singapore.</li><li>Holding annual general meetings.</li></ul>"},{"name":"How to qualify for audit exemption?","content":"<p>There are two cases where audit exemption is granted: small companies and dormant companies.</p><p>To qualify for \\"small company\\", a company must meet 2 out 3 following conditions:</p><ul><li>Its total annual revenue at the end of the financial year in question must not exceed SG$10 million;</li><li>Its total assets evaluated at the end of the financial year in question must not exceed SG$10 million;</li><li>Its total number of full-time employers on the payroll must not exceed 50.</li></ul><p>A company is deemed to be dormant if it has no accounting transactions for the financial year in question or has not started business since its incorporation.</p>"}]},{"name":"Taxation","faqs":[{"name":"Which taxes must a company in Singapore pay annually?","content":"<p>A Singapore company is basically taxed for its profits, regardless of the sources. For the first three years, the company is levied from 0% to 17% depending on its incomes. After that, the tax rates are 8.5% and 17%, respectively for the first 300,000 SGD and the remainder.</p>"},{"name":"What is the corporate profit tax for Singapore companies?","content":"<p>The standard corporate income tax for the year of assessment (YA) 2020 stands at 17% applied on chargeable income of both domestic or foreign companies, subject to exemption as follows:</p><table><tbody><tr><td style=\\"border-bottom: none\\">Partial tax exemption for companies:</td><td style=\\"border-bottom: none\\"></td></tr><tr><td><ul><li>First $10,000 of chargeable income</li><li>Next $190,000 of chargeable income</li></ul></td><td style=\\"width: 16%\\" >75% exemption<br>50% exemption</td></tr><tr><td style=\\"border-bottom: none\\">Tax exemption for startups meeting certain conditions in the first three consecutive YAs:</td><td style=\\"border-bottom: none\\"></td></tr><tr><td><ul><li>First $100,000 of chargeable income</li><li>Next $100,000 of chargeable income</li></ul></td><td>75% exemption<br>50% exemption</td></tr></tbody></table><p>The corporate income tax rebate for YA 2019 is 20% and capped at $10,000. In addition, there is no capital gains or dividend tax in Singapore.</p>"},{"name":"How to qualify for start-up tax exemption in Singapore?","content":"<p>In order to qualify for start-up exemption, a newly incorporated company in Singapore must satisfy below conditions:</p><ul><li>Be incorporated in Singapore (other than a company limited by guarantee**);</li><li>Be a tax resident* in Singapore for that YA;</li><li>Have no more than 20 shareholders throughout the basis period for that YA where:<ul><li>All of the shareholders are individuals beneficially and directly holding the shares in their own names; OR</li><li>At least one shareholder is an individual beneficially and directly holding at least 10% of the issued ordinary shares of the company.</li></ul></li></ul><p>*A company is resident in Singapore if the control and management of its business are exercised in Singapore.</p>"}]}]}}');
;// CONCATENATED MODULE: ./pages/sg/company-incorporation/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "sg",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(company_incorporation, {
      data: data,
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 28332:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg/company-incorporation",
      function () {
        return __webpack_require__(59490);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9749:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nation":"Index_nation__6sQAT","emailAddress":"Index_emailAddress__skFes","entityName":"Index_entityName__Uv6qK","entityType":"Index_entityType__OPj0B"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,4868,4090,9738,7447,2314,9156,975,2888,179], function() { return __webpack_exec__(28332); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);